//import * as Raven from 'raven-js';
// import * as Sentry from "@sentry/browser";

import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {IonicStorageModule} from '@ionic/storage';

import es from '@angular/common/locales/es';
import {registerLocaleData} from '@angular/common';

registerLocaleData(es);

import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {Network} from '@ionic-native/network';
import {Push} from '@ionic-native/push';
import {Camera} from '@ionic-native/camera';
import {Crop} from '@ionic-native/crop';
import {File} from '@ionic-native/file';
import {FileTransfer} from '@ionic-native/file-transfer';
import {FileOpener} from '@ionic-native/file-opener';
import {SocialSharing} from '@ionic-native/social-sharing';
import {PhotoViewer} from '@ionic-native/photo-viewer';
import {AppVersion} from '@ionic-native/app-version';
import {Insomnia} from '@ionic-native/insomnia';
//import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';

import {YoutubeVideoPlayer} from '@ionic-native/youtube-video-player';
import {BarcodeScanner} from '@ionic-native/barcode-scanner';
import {Calendar} from '@ionic-native/calendar';

import {PipesModule} from '../pipes/pipes.module';
import {DirectivesModule} from '../directives/directives.module';

import {Globales} from '../classes/funciones';
import {Calendario} from '../classes/calendario';
import {CatalogoPDF} from '../classes/catalogoPDF';
import {Impresion} from '../classes/impresion';
import {Impression2} from "../classes/inpresion2";
import {Inventarios} from '../classes/inventarios';
import {NetInfoService} from '../services/NetInfoService';
import {UserService} from '../services/UserService';
import {NotificacionesService} from '../services/NotificacionesService';

import {TareasService} from '../services/TareasService';
import {ChecklistService} from '../services/ChecklistService';

import {FamiliasTareasService} from '../services/FamiliasTareasService';
import {LocalesService} from '../services/LocalesService';
import {UbicaconesService} from '../services/UbicaconesService';
import {AlmacenesService} from '../services/AlmacenesService';
import {RecetasService} from '../services/RecetasService';
import {PedidosService} from '../services/PedidosService';
import {AlbaranesService} from '../services/AlbaranesService';
import {ProveedoresService} from '../services/ProveedoresService';
import {UsuariosService} from '../services/UsuariosService';
import {EscandallosService} from '../services/EscandallosService';
import {ProductosService} from '../services/ProductosService';
import {FiltrosServices} from '../services/FiltrosServices';
import {RolesService} from '../services/RolesService';
import {StockAlmacenService} from '../services/StockAlmacenService';
import {StockPreparacionesService} from '../services/StockPreparacionesService';
import {StockRecargasService} from '../services/StockRecargasService';
import {PeriodosService} from '../services/PeriodosService';
import {PartidasService} from '../services/PartidasService';
import {CategoriasProductosService} from '../services/CategoriasProductosService';
import {ElaboracionesService} from '../services/ElaboracionesService';
import {DepartamentosService} from '../services/DepartamentosService';
import {DispositivosService} from '../services/DispositivosService';
import {InventariosService} from '../services/InventariosService';
import {RevisionesService} from '../services/RevisionesService';
import {UnidadesService} from '../services/UnidadesService';
import {EtiquetasService} from "../services/EtiquetasService";
import {ProductosAlergenosService} from "../services/ProductosAlergenosService";
import {ProductosFamiliasService} from '../services/ProductosFamiliasService';
import {IvasService} from '../services/IvasService';
import {TutorialesService} from '../services/TutorialesService';
import {CategoriasTopProductosService} from '../services/CategoriasTopProductosService';
import {RecargasService} from '../services/RecargasService';
import {MermasService} from '../services/MermasService';
import {MermasTiposService} from '../services/MermasTiposService';
import {CuadranteService} from '../services/CuadranteService';
import {FamiliasEscandallosService} from '../services/FamiliasEscandallosService';
import {CierresCajaService} from '../services/CierresCajaService';
import {GastosGeneralesService} from '../services/GastosGeneralesService';
import {AdelantosService} from '../services/AdelantosService';
import {ExtrasService} from '../services/ExtrasService';
import {TurnosService} from '../services/TurnosService';
import {TipoIngresosService} from '../services/TipoIngresosService';
import {FamiliasGastosService} from "../services/FamiliasGastosService";
import {GastosPersonalService} from "../services/GastosPersonalService";
import {EbitdaService} from "../services/EbitdaService";
import {FichejesService} from "../services/FichejesService";
import {VacacionesService} from "../services/VacacionesService";
import {VacacionesTiposService} from "../services/VacacionesTiposService";
import {MaquinasService} from "../services/MaquinasService";
import {ServiciosRestauracionService} from "../services/ServiciosRestauracionService";
import {ImagenesValoracionesService} from "../services/ImagenesValoracionesService";
import {ProduccionesFlitroService} from "../services/ProduccionesFlitroService";
import {CarpetasService} from "../services/CarpetasService";
import {PermisosNotificacionesService} from "../services/PermisosNotificacionesService";
import {RecetasFamiliasService} from "../services/RecetasFamiliasService";
import {TraspasosService} from "../services/TraspasosService";

import {Ionic2RatingModule} from "ionic2-rating";
import {CalendarModule} from "ion2-calendar";
import {Angular2SignaturepadModule} from 'angular2-signaturepad';
import {IonicSelectableModule} from 'ionic-selectable';

import {MyApp} from './app.component';
import {InterceptorProvider} from '../providers/interceptor/interceptor';
import {PrioridadesAveriaService} from '../services/PrioridadesAveriaService';
import {ChecklistModelosService} from "../services/ChecklistModelosService";
import {InAppBrowser} from "@ionic-native/in-app-browser/ngx";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {BackgroundMode} from "@ionic-native/background-mode";
import {AltasService} from '../services/AltasService';
import {TipoAveriasService} from '../services/TipoAveriasService';
import {FranquiciasService} from '../services/FranquiciasService';
import {Franquiciados} from '../classes/franquiciados';
import {FestivosService} from '../services/FestivosService';
import {OfflineInventarioService} from '../services/OfflineInventarioService';

/*

Sentry.init({
  dsn: "https://17969f951b2c47ea9314ff2d33b76326@sentry.io/1270944",
  release: '3.0.8',
});


export class SentryErrorHandler implements ErrorHandler {
  constructor() {
  }

  handleError(error) {
    const eventId = Sentry.captureException(error.originalError || error);
    Sentry.showReportDialog({eventId});
  }
}
*/

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    Ionic2RatingModule,
    CalendarModule,
    Angular2SignaturepadModule,
    IonicSelectableModule,
    PipesModule,
    DirectivesModule,

    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthShortNames: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
      dayShortNames: ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'],
      backButtonText: '',
      platforms: {
        android: {
          tabsHighlight: true,
          tabsHideOnSubPages: false
        },
        ios: {
          ionistatusbarPadding: true
        }
      }
    }),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    AndroidPermissions,
    InAppBrowser,
    StatusBar,
    SplashScreen,
    BackgroundMode,
    Network,
    Push,
    Camera,
    Crop,
    File,
    FileTransfer,
    FileOpener,
    SocialSharing,
    PhotoViewer,
    AppVersion,
    Insomnia,
    YoutubeVideoPlayer,
    BarcodeScanner,
    Calendar,
    Calendar,

    Globales,
    Calendario,
    CatalogoPDF,
    Franquiciados,
    Impresion,
    Impression2,
    Inventarios,
    NetInfoService,
    UserService,
    NotificacionesService,

    TareasService,
    ChecklistService,

    FamiliasTareasService,
    ProductosFamiliasService,
    ProductosAlergenosService,
    EtiquetasService,
    IvasService,
    UnidadesService,
    LocalesService,
    FranquiciasService,
    UbicaconesService,
    AlmacenesService,
    RecetasService,
    PedidosService,
    AlbaranesService,
    ProveedoresService,
    UsuariosService,
    EscandallosService,
    ProductosService,
    FiltrosServices,
    RolesService,
    StockAlmacenService,
    StockPreparacionesService,
    StockRecargasService,
    PeriodosService,
    PartidasService,
    CategoriasProductosService,
    ElaboracionesService,
    DepartamentosService,
    DispositivosService,
    InventariosService,
    RevisionesService,
    TutorialesService,
    CategoriasTopProductosService,
    RecargasService,
    MermasService,
    MermasTiposService,
    CuadranteService,
    FamiliasEscandallosService,
    CierresCajaService,
    AdelantosService,
    ExtrasService,
    TurnosService,
    TipoIngresosService,
    TipoAveriasService,
    FamiliasGastosService,
    GastosGeneralesService,
    GastosPersonalService,
    EbitdaService,
    FichejesService,
    VacacionesService,
    VacacionesTiposService,
    MaquinasService,
    ServiciosRestauracionService,
    ImagenesValoracionesService,
    ProduccionesFlitroService,
    CarpetasService,
    PermisosNotificacionesService,
    RecetasFamiliasService,
    TraspasosService,
    PrioridadesAveriaService,
    ChecklistModelosService,
    AltasService,
    FestivosService,
    OfflineInventarioService,

    {provide: LOCALE_ID, useValue: 'es'},
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true},
    //{provide: ErrorHandler, useClass: SentryErrorHandler}
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts